import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/components/GlobalComponents.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3426056977/src/mb-website/src/components/Header.jsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/hooks/WebCallWidget.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3426056977/src/mb-website/src/styles/globals.scss");
